import useUpdateGlobalPosition from "./useUpdateGlobalPosition.js";
import useUpdateLeftPosition from "./useUpdateLeftPosition.js";
import useUpdateTopPosition from "./useUpdateTopPosition.js"
import useBuildDataAndTree from "./useBuildDataAndTree.js";


const useDeleteSourceOccurence = () => {
  const updateGlobalPosition = useUpdateGlobalPosition();
  const updateLeftPosition = useUpdateLeftPosition();
  const updateTopPosition = useUpdateTopPosition();
  const buildDataAndTree = useBuildDataAndTree();

  const deleteData = (containers, ids) => {
    
    deleteSourceOccurence (containers, ids)
    buildDataAndTree(containers, true)
  };

  const deleteSourceOccurence = (containers, ids, grandFather) => {
    if (!containers.metaData) return;
    if (containers.metaData.map((item, index) => {
      if (ids.includes(item.id)) {
        if (containers.type == "ListView"){
          updateTopPosition(containers, item.styles.top.value, "0px", index +1);
          updateGlobalPosition(containers);
        }
        if (containers.type == "SplitListView"){
          updateLeftPosition(containers, item.styles.left.value, "0px", item.styles.height.value, index +1);
          updateGlobalPosition(containers);
        }

        if (containers.type == "Header"){      
          grandFather.metaData.filter(item => {   
            if (item.type == "Rows") {
              item.metaData = item.metaData.filter(row => !ids.includes(row.headerId))
            }
          }) 
          grandFather.metaData.filter(item => {   
            if (item.type == "Filter") {
              item.metaData = item.metaData.filter(row => !ids.includes(row.headerId))
            }
          })  
        }
        
        if (containers.type != "Rows" && containers.type != "Filter" && item.type != "Rows" && item.type != "Filter" 
            && item.type != "Header" && item.type != "SearchGrid")
          containers.metaData = containers.metaData.filter((tool) => !ids.includes(tool.id));
        
        
      }
      else 
        deleteSourceOccurence(item, ids, containers);
    }));
  };

  return deleteData;
};

export default useDeleteSourceOccurence;
